import React, { useEffect } from 'react'
import { Col, Nav, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import { Route, useNavigate } from 'react-router-dom'
import { Routes } from 'react-router-dom'
import { Link } from 'react-router-dom'

import { Chat } from './Tabs/Chat/Chat'
import { Home } from './Tabs/Home/Home'
import { PiHandCoinsFill } from "react-icons/pi";

import { AiFillHome } from 'react-icons/ai';
import { BsPeopleFill, BsPersonPlus } from "react-icons/bs";
import { Requests } from './Tabs/Requests/Requests'
import Cookies from 'js-cookie'
import { Connector } from './Components/Connector'
import { useConnector } from './Hooks/useConnector'
import { useTestToken } from './Hooks/useTestToken'
import { BiLogOut } from 'react-icons/bi'
import { Players } from './Tabs/Players/Players'
import { NewPlayerRequests } from './Tabs/NewPlayerRequest/NewPlayerRequest'
import { IoChatbubbleEllipsesSharp } from 'react-icons/io5'
import { MdOutlineContactSupport } from 'react-icons/md'
import { AnnonChat } from './Tabs/ChatWithAnnon/AnnonChat'
import { useUnseenChats } from './Hooks/useUnseenChats'
import { SeenChatTag } from './Components/SeenChatTag'
import { useAdminInfo } from '../../hooks/useAdminInfo'
import { ProtectedRouteGestor } from '../../ProtectedRoutes/ProtectedRouteGestor'

export const Dashboard = () => {
    const navigate = useNavigate();

    const { connectionStatus, handleExtractData } = useConnector()
    const { userInfo, loadingConnection } = useTestToken()
    const { unseenChats, unseenAnnonChats } = useUnseenChats()
    const { adminInfo } = useAdminInfo()
    const hasGestorURL = !!adminInfo?.gestorUrl

    const renderNavLink = ({ to, icon, text, isMobile }: { to: string, icon: any, text: string, isMobile: boolean }) => {

        const showTag = text === 'Chat Jugadores' || text === 'Soporte'
        const link = (
            <Nav.Link
                as={Link}
                to={to}
                className={`d-flex align-items-center justify-content-center gap-3 px-2 py-3 text-secondary hover-primary position-relative`}
            >
                {React.cloneElement(icon, { size: 24 })}
                {showTag && <div className='position-absolute d-flex align-items-center justify-content-center text-center' style={{ top: '5px', right: '5px' }}>
                    <SeenChatTag unseenChats={unseenChats} unseenAnnonChats={unseenAnnonChats} type={text === 'Chat Jugadores' ? 'chats' : 'annonChats'} />
                </div>}
            </Nav.Link>
        );

        return (
            <OverlayTrigger
                placement={isMobile ? "bottom" : "top"}
                overlay={<Tooltip>{text}</Tooltip>}
            >
                {link}
            </OverlayTrigger>
        )
    };


    const renderLogoutButton = ({ icon, text, isMobile }: { icon: any, text: string, isMobile: boolean }) => {
        const link = (
            <Nav.Link
                onClick={() => {
                    Cookies.remove('Token')
                    Cookies.remove('loggedAs')
                    navigate('/login')
                }}
                className={`d-flex align-items-center justify-content-center gap-3 px-2 py-3 text-secondary hover-primary`}
            >
                {React.cloneElement(icon, { size: 24 })}
            </Nav.Link>
        );

        return (
            <OverlayTrigger
                placement={isMobile ? "bottom" : "top"}
                overlay={<Tooltip>{text}</Tooltip>}
            >
                {link}
            </OverlayTrigger>
        )
    }

    useEffect(() => {
        const token = Cookies.get('Token');
        if (!token) {
            navigate('/login')
        }
    }, [navigate])

    if (loadingConnection) {
        return <div className='d-flex justify-content-center align-items-center vh-100'>
            <Spinner animation="border" variant="primary" />
        </div>
    }


    // if (!connected) {
    //     return (
    //         <div className='d-flex flex-column justify-content-center align-items-center vh-100'>
    //             <div className='text-center'>No estás conectado a la plataforma</div>
    //             <div className='mt-3'>
    //                 <Button variant='primary' onClick={() => navigate('/login')}>Iniciar Sesión</Button>
    //             </div>
    //         </div>
    //     )
    // }


    return (
        <div>
            <div className="position-relative">

                <Row className='d-flex justify-content-center mt-0 d-md-none mt-md-3'>
                    <Nav className="flex-row justify-content-around align-items-center" style={{ fontSize: '16px' }}>
                        <Connector mobile={true} handleExtractData={handleExtractData} connectionStatus={connectionStatus} userInfo={userInfo} />
                        {renderNavLink({ to: "/dashboard", icon: <AiFillHome />, text: "Home", isMobile: true })}
                        {hasGestorURL && renderNavLink({ to: "/dashboard/chat", icon: <IoChatbubbleEllipsesSharp />, text: "Chat Jugadores", isMobile: true })}
                        {hasGestorURL && renderNavLink({ to: "/dashboard/players", icon: <BsPeopleFill />, text: "Jugadores", isMobile: true })}
                        {hasGestorURL && renderNavLink({ to: "/dashboard/requests", icon: <PiHandCoinsFill />, text: "Solicitudes Carga/Retiro", isMobile: true })}
                        {hasGestorURL && renderNavLink({ to: "/dashboard/new-player-requests", icon: <BsPersonPlus />, text: "Solicitudes Nuevos Jugadores", isMobile: true })}
                        {hasGestorURL && renderNavLink({ to: "/dashboard/support", icon: <MdOutlineContactSupport />, text: "Soporte", isMobile: true })}
                        <div className="mt-auto">
                            {renderLogoutButton({ icon: <BiLogOut />, text: "Cerrar Sesión", isMobile: true })}
                        </div>
                    </Nav>
                </Row>


                <Row>
                    <Col
                        style={{
                            maxWidth: '100px',
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            height: '100vh',
                            zIndex: 1000
                        }}
                        className="d-none d-md-block bg-white shadow-md"
                    >
                        <Nav className="flex-column m-3 d-flex flex-column justify-content-between" style={{ fontSize: '16px' }}>
                            <div>
                                <Connector mobile={false} handleExtractData={handleExtractData} connectionStatus={connectionStatus} userInfo={userInfo} />
                                <div className="w-100 border-bottom border-dark opacity-50 mb-3"></div>

                                <div>
                                    {renderNavLink({ to: "/dashboard", icon: <AiFillHome />, text: "Home", isMobile: false })}
                                    {hasGestorURL && renderNavLink({ to: "/dashboard/chat", icon: <IoChatbubbleEllipsesSharp />, text: "Chat Jugadores", isMobile: false })}
                                    {hasGestorURL && renderNavLink({ to: "/dashboard/players", icon: <BsPeopleFill />, text: "Jugadores", isMobile: false })}
                                    {hasGestorURL && <div className="w-100 border-bottom border-dark opacity-50 mb-3"></div>}
                                    {hasGestorURL && <div className='text-center text-secondary mb-2' style={{ fontSize: '10px' }}>Solicitudes</div>}
                                    {hasGestorURL && renderNavLink({ to: "/dashboard/requests", icon: <PiHandCoinsFill />, text: "Solicitudes Carga/Retiro", isMobile: false })}
                                    {hasGestorURL && renderNavLink({ to: "/dashboard/new-player-requests", icon: <BsPersonPlus />, text: "Solicitudes Jugadores", isMobile: false })}
                                    {hasGestorURL && <div className="w-100 border-bottom border-dark opacity-50 mb-3"></div>}
                                    {hasGestorURL && <div className='text-center text-secondary mb-2' style={{ fontSize: '10px' }}>Soporte</div>}
                                    {hasGestorURL && renderNavLink({ to: "/dashboard/support", icon: <MdOutlineContactSupport />, text: "Soporte", isMobile: false })}
                                    <div className='mt-5'>
                                        {renderLogoutButton({ icon: <BiLogOut />, text: "Cerrar Sesión", isMobile: false })}
                                    </div>
                                </div>

                            </div>
                        </Nav>
                    </Col>



                    <Col md={2}
                        className="d-none d-md-block bg-white shadow-md"
                        style={{
                            width: '100px',
                            minWidth: '100px'
                        }}></Col>


                    <Col style={{
                        height: '100vh',
                        overflowY: 'auto',
                    }}
                        className="px-3 px-md-5 pt-0 pt-md-3"
                    >
                        <Routes>
                            <Route path="/" element={<Home userInfo={userInfo} />} />
                            <Route path="/chat" element={<ProtectedRouteGestor element={<Chat />} hasGestorURL={hasGestorURL} />} />
                            <Route path="/support" element={<ProtectedRouteGestor element={<AnnonChat />} hasGestorURL={hasGestorURL} />} />
                            <Route path="/requests" element={<ProtectedRouteGestor element={<Requests />} hasGestorURL={hasGestorURL} />} />
                            <Route path="/players" element={<ProtectedRouteGestor element={<Players />} hasGestorURL={hasGestorURL} />} />
                            <Route path="/new-player-requests" element={<ProtectedRouteGestor element={<NewPlayerRequests />} hasGestorURL={hasGestorURL} />} />
                        </Routes>
                    </Col>
                </Row>
            </div>
        </div >
    )
}
